import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

const EventDatesOverviewView = () => import('@/modules/event-reservations/views/EventDatesOverviewView.vue')

export const eventReservationRoutes: RouteRecordRaw[] = [
  {
    path: '/event-dates',
    name: 'EventDatesOverview',
    component: EventDatesOverviewView,
    meta: {
      permission: PERMISSIONS.ESHOP.MANAGE,
      projectScoped: true,
      title: 'Termíny školení'
    }
  }
]
